module.exports = __webpack_public_path__ + "static/media/watermark-left.c6b6e103.png";